<template>
  <div class="min-h-screen bg-[var(--alohin-light)] flex flex-col">
    <HeaderComponent />
    <main class="flex-1">
      <router-view />
    </main>
    <FooterComponent />
    <Toast />

    <transition
      enter-active-class="transition-opacity duration-200"
      leave-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
    >
      <div
        v-if="loading.isLoading"
        class="fixed inset-0 z-[200] flex items-center justify-center bg-slate-950/25 backdrop-blur-sm"
      >
        <div class="flex min-w-[220px] items-center gap-4 rounded-3xl border border-white/50 bg-white/90 px-6 py-5 shadow-2xl shadow-slate-900/10">
          <div class="h-11 w-11 animate-spin rounded-full border-4 border-orange-200 border-t-orange-500"></div>
          <div>
            <p class="text-sm font-bold uppercase tracking-[0.2em] text-orange-500">Aguarde</p>
            <p class="text-base font-semibold text-slate-800">Carregando dados...</p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script setup>
import HeaderComponent from './layout/HeaderComponent.vue';
import FooterComponent from '@/layout/FooterComponent.vue';
import Toast from '@/components/Toast.vue';
import { useLoadingStore } from '@/store/loadingStore';

const loading = useLoadingStore();
</script>